import Swiper, { Keyboard, Mousewheel, Navigation, Pagination, SwiperOptions } from "swiper";

export function initInstagramFeedSliders(root: ParentNode = document): void {
	const sliders = root.querySelectorAll<HTMLElement>(
		".instagram-feed-slider:not([data-swiper-initialized])",
	);

	sliders.forEach((slider) => {
		const paginationEl = slider.querySelector(".image-swiper-pagination");
		const nextEl = slider.querySelector(".swiper-button-next");
		const prevEl = slider.querySelector(".swiper-button-prev");

		new Swiper(slider, {
			modules: [Navigation, Pagination, Keyboard, Mousewheel],
			// card width comes from CSS, full-bleed row like in the design
			slidesPerView: "auto",
			spaceBetween: 18,
			loop: true,
			grabCursor: true,
			speed: 800,
			keyboard: { enabled: true },
			// only horizontal wheel/trackpad gestures, vertical scrolling keeps scrolling the page
			mousewheel: { forceToAxis: true },
			navigation:
				nextEl && prevEl
					? {
							nextEl,
							prevEl,
						}
					: undefined,
			pagination: paginationEl
				? {
						el: paginationEl,
						type: "fraction",
					}
				: undefined,
		} as SwiperOptions);

		slider.setAttribute("data-swiper-initialized", "1");

		const paginationCurrent = slider.querySelector(
			".swiper-pagination-fraction .swiper-pagination-current",
		);
		paginationCurrent?.nextSibling?.replaceWith(" | ");
	});
}

declare global {
	interface Window {
		ytInitInstagramFeedSliders?: typeof initInstagramFeedSliders;
	}
}

window.ytInitInstagramFeedSliders = initInstagramFeedSliders;
